import {
  EncryptStorage
} from 'encrypt-storage';

export const encryptStorage = EncryptStorage(process.env.VUE_APP_ENCRYPTION_STORAGE, {
  storageType: 'sessionStorage',
  stateManagementUse: true,
});